import { EditOutlined, EyeOutlined, MailOutlined, PlusOutlined, SettingOutlined, StopOutlined } from "@ant-design/icons";
import { Input, Modal, PageHeader, Tag, Tooltip, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, fmtFechaDia } from "../../../Components/Items";
import MandarCorreoRMACompra from "./MandarCorreoRMACompra/MandarCorreoRMACompra";
import {
  ESTADOS_EDITABLES,
  ESTADOS_RMA_COMPRA,
  ETIQUETA_ESTADO_RMA_COMPRA,
  VALOR_ABIERTOS,
  VALOR_TODOS,
  dinero,
} from "./rmaCompraComun";

const ESTILO_TOOLTIP = { fontSize: "10px", padding: "1px 5px", minHeight: "auto" };

class RMAsCompra extends Component {
  tableRef = null;
  state = {
    rmas: [],
    loading: false,
    valor: VALOR_ABIERTOS,
    totalRecords: 0,
    textoFiltro: "",
    modalCorreoVisible: false,
    modalId: null,
  };

  consultarRMAs(params) {
    this.setState({ loading: true });
    axios
      .post("rmaCompra/selectRMAsCompra", { empresaId: this.props.empresaId, ...params }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loading: false, rmas: [] });
        } else {
          this.setState({ loading: false, rmas: res.data.data, totalRecords: res.data.totalRecords || 0 });
        }
      })
      .catch(() => this.setState({ loading: false }));
  }

  recargar() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor, textoFiltro: this.state.textoFiltro });
    }
  }

  verRMA(id) {
    this.props.history.push("/panel/vistaRMACompra", { id, modo: "ver" });
  }

  editarRMA(id) {
    this.props.history.push("/panel/vistaRMACompra", { id, modo: "editar" });
  }

  // El motivo se pide en un modal: Popconfirm no deja escribir.
  cancelarRMA(record) {
    let motivoCancelacion = "";
    Modal.confirm({
      title: `¿Cancelar el RMA ${record.folio}?`,
      content: (
        <Input.TextArea
          rows={2}
          placeholder="Motivo de la cancelación (opcional)"
          onChange={(e) => (motivoCancelacion = e.target.value)}
        />
      ),
      okText: "Cancelar RMA",
      okButtonProps: { danger: true },
      cancelText: "Regresar",
      onOk: () =>
        axios
          .post(
            "rmaCompra/cancelarRMACompra",
            { empresaId: this.props.empresaId, rmaId: record._id, motivoCancelacion },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            if (res.data.success === 2) message.success("RMA cancelado");
            else message.error(res.data.message || "No se pudo cancelar el RMA");
            this.recargar();
          }),
    });
  }

  render() {
    const columns = [
      { title: "Folio", dataIndex: "folio", key: "folio", buscar: "folio", width: "9%", sorter: true },
      {
        title: "Fecha",
        dataIndex: "fechaSolicitud",
        key: "fechaSolicitud",
        width: "8%",
        sorter: true,
        render: (value) => fmtFechaDia(value),
      },
      { title: "Proveedor", dataIndex: "proveedorNombre", key: "proveedorNombre", buscar: "proveedorNombre", width: "22%" },
      { title: "Motivo", dataIndex: "motivo", key: "motivo", buscar: "motivo", width: "14%", render: (value) => value || "—" },
      {
        title: "No. RMA proveedor",
        dataIndex: "numeroAutorizacionProveedor",
        key: "numeroAutorizacionProveedor",
        width: "9%",
        render: (value) => value || "—",
      },
      { title: "Renglones", dataIndex: "totalRenglones", key: "totalRenglones", width: "6%", align: "center" },
      {
        title: "Monto (MXN)",
        dataIndex: "montoSolicitado",
        key: "montoSolicitado",
        width: "10%",
        align: "right",
        sorter: true,
        render: (value) => (
          <Tooltip title="Con impuestos, calculado de las facturas" overlayInnerStyle={ESTILO_TOOLTIP}>
            {dinero(value)}
          </Tooltip>
        ),
      },
      {
        title: "Garantía",
        dataIndex: "fueraDePlazo",
        key: "fueraDePlazo",
        width: "8%",
        render: (value, record) =>
          value ? (
            <Tag color="orange">Fuera de plazo</Tag>
          ) : record.diasDesdeCompra !== null && record.diasDesdeCompra !== undefined ? (
            `${record.diasDesdeCompra} días`
          ) : (
            "—"
          ),
      },
      {
        title: "Estatus",
        dataIndex: "estado",
        key: "estado",
        width: "9%",
        render: (value) => {
          const etiqueta = ETIQUETA_ESTADO_RMA_COMPRA[value];
          return etiqueta ? <Tag color={etiqueta.color}>{etiqueta.texto}</Tag> : "—";
        },
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "11%",
        render: (value, record) => {
          const botones = [
            <Tooltip key="ver" title="Ver RMA" placement="top" overlayInnerStyle={ESTILO_TOOLTIP}>
              <ButtonItem type="default" size="small" lila icon={<EyeOutlined />} onClick={() => this.verRMA(record._id)} />
            </Tooltip>,
            <Tooltip key="correo" title="PDF / Mandar correo" placement="top" overlayInnerStyle={ESTILO_TOOLTIP}>
              <ButtonItem
                type="default"
                size="small"
                blanco
                icon={<MailOutlined />}
                onClick={() => this.setState({ modalCorreoVisible: true, modalId: record._id })}
              />
            </Tooltip>,
          ];

          if (ESTADOS_EDITABLES.includes(record.estado)) {
            botones.push(
              <Tooltip key="editar" title="Editar RMA" placement="top" overlayInnerStyle={ESTILO_TOOLTIP}>
                <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.editarRMA(record._id)} />
              </Tooltip>
            );
          }

          if (record.estado !== ESTADOS_RMA_COMPRA.CANCELADO && record.estado !== ESTADOS_RMA_COMPRA.CERRADO) {
            botones.push(
              <Tooltip key="cancelar" title="Cancelar" placement="top" overlayInnerStyle={ESTILO_TOOLTIP}>
                <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} onClick={() => this.cancelarRMA(record)} />
              </Tooltip>
            );
          }

          return <div className="acciones-container">{botones}</div>;
        },
      },
    ];

    return (
      <>
        <PageHeader
          title="RMA Compras · Devoluciones a proveedores"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 && (
                <SegmentedItem
                  options={[
                    { label: "Abiertos", value: VALOR_ABIERTOS },
                    { label: "Solicitados", value: ESTADOS_RMA_COMPRA.SOLICITADO },
                    { label: "Por resolver", value: ESTADOS_RMA_COMPRA.POR_RESOLVER },
                    { label: "Cerrados", value: ESTADOS_RMA_COMPRA.CERRADO },
                    { label: "Cancelados", value: ESTADOS_RMA_COMPRA.CANCELADO },
                    { label: "Todos", value: VALOR_TODOS },
                  ]}
                  onChange={(value) => {
                    if (this.tableRef) {
                      this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                    }
                    this.setState({ valor: value });
                  }}
                  value={this.state.valor}
                />
              )}
              <Tooltip title="Configuración de RMA de compras">
                <ButtonItem
                  type="default"
                  blanco
                  icon={<SettingOutlined />}
                  onClick={() => this.props.history.push("/panel/configuracionRMACompra")}
                />
              </Tooltip>
              <ButtonItem
                type="primary"
                olivo
                className="botonAgregar"
                onClick={() => this.props.history.push("/panel/vistaRMACompra", { modo: "agregar" })}
                icon={<PlusOutlined />}
              >
                Agregar
              </ButtonItem>
            </>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          onFetchData={this.consultarRMAs.bind(this)}
          anadirValorFiltro={this.state.valor}
          size="small"
          dataSource={this.state.rmas}
          columns={columns}
          scroll={{ x: "max-content" }}
          filterStorageKey={"rmaCompra" + this.props.empresaId}
          onRow={(record) => ({ onDoubleClick: () => this.verRMA(record._id) })}
          setValor={(valor) => this.setState({ valor })}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorDefault={VALOR_ABIERTOS}
        />
        <MandarCorreoRMACompra
          visible={this.state.modalCorreoVisible}
          id={this.state.modalId}
          onCerrar={() => this.setState({ modalCorreoVisible: false, modalId: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(RMAsCompra);
